import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ApiService from '../util/ApiService';
import {Form} from 'react-bootstrap';
import Swal from 'sweetalert2';
import Select from "react-select";

const OfficerModal = ({show, onHide, officerData = {}, onSaveSuccess}) => {
    const [loadingSave, setLoadingSave] = useState(false);
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [formData, setFormData] = useState({
        id: officerData?.id || '',
        name: officerData?.name || '',
        email: officerData?.email || '',
         ddd: officerData?.ddd || '',
         phone: officerData?.phone || '',
    });



    useEffect(() => {
        if (show) {

        }
    }, [show]);



    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const formatCpfCnpj = (value) => {
        // Remove tudo que não for número
        value = value.replace(/\D/g, "");

        if (value.length <= 11) {
            // CPF: 000.000.000-00
            return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        } else {
            // CNPJ: 00.000.000/0000-00
            return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
    };



    const handleCpfCnpjChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Remove tudo que não for número
        const formattedValue = formatCpfCnpj(value); // Aplica a formatação

        setCpfCnpj(formattedValue); // Define o valor formatado no estado local
        setFormData((prevData) => ({
            ...prevData,
            cpf: value // Salva apenas os números no formData
        }));
    };

    const onlyNumbers = (value) => {
        return value.replace(/\D/g, ""); // Remove tudo que não for número
    };


    const formatPhoneWithoutDDD = (value) => {
        value = onlyNumbers(value);

        if (value.length === 9) {
            // Celular sem DDD: 00000-0000
            return value.replace(/(\d{5})(\d{4})/, "$1-$2");
        } else if (value.length === 8) {
            // Telefone fixo sem DDD: 0000-0000
            return value.replace(/(\d{4})(\d{4})/, "$1-$2");
        } else {
            // Exibe parcialmente formatado
            return value.replace(/(\d{0,5})(\d{0,4})/, "$1-$2").trim();
        }
    };


    const handleDDDChange = (e) => {
        const value = onlyNumbers(e.target.value);
        setFormData((prevData) => ({
            ...prevData,
            ddd: value, // Salva apenas números no DDD
        }));
    };

    const handlePhoneChange = (e) => {
        const value = onlyNumbers(e.target.value);
        const formattedValue = formatPhoneWithoutDDD(value); // Formata o telefone (sem DDD)

        setFormData((prevData) => ({
            ...prevData,
            phone: formattedValue, // Salva o telefone formatado
        }));
    };




    const handleSave = async () => {
        try {
            setLoadingSave(true);
            const response = await ApiService.send(
                formData.id ? 'put' : 'post',
                `${process.env.REACT_APP_URL_API}users-officer/register`,
                formData,
                true
            );

            if (response?.code === 200) {
                Swal.fire('Sucesso', 'Funcionário salvo com sucesso!', 'success')
                    .then(() => {
                        onHide(true);
                    });
            } else {
                throw new Error(response?.data?.message || 'Erro ao salvar funcionário.');
            }
        } catch (error) {
            ApiService.handleApiError(error);

        } finally {
            setLoadingSave(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Cadastrar Funcionário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="form-group col-12">
                        <label>Nome</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name || ''}
                            onChange={handleInputChange}
                            placeholder="Digite o nome"
                        />
                    </div>
                    <div className="form-group col-12">
                        <label>Email</label>
                        <input
                            type="mail"
                            className="form-control"
                            name="email"
                            value={formData.email || ''}
                            onChange={handleInputChange}
                            placeholder="Digite o email"
                        />
                    </div>
                    <div className="form-group col-12">
                        <label>CPF/CNPJ</label>
                        <input
                            type="text"
                            name="cpf"
                            maxLength={18} // Limite para CPF (14) e CNPJ (18)
                            className="form-control"
                            value={cpfCnpj} // Exibe o valor formatado
                            onChange={handleCpfCnpjChange}
                            placeholder="Digite o CPF ou CNPJ"
                            required
                        />
                    </div>

                    <div className="row">
                        <div className="form-group col-3">
                            <label>DDD</label>
                            <input
                                type="text"
                                name="ddd"
                                className="form-control"
                                maxLength={2} // Limite para DDD
                                value={formData.ddd || ''} // Exibe apenas números
                                onChange={handleDDDChange}
                                placeholder="DDD"
                                required
                            />
                        </div>
                        <div className="form-group col-9">
                            <label>Telefone</label>
                            <input
                                type="text"
                                className="form-control"
                                name="phone"
                                maxLength={10} // Limite para telefone sem DDD
                                value={formData.phone || ''} // Exibe o valor formatado
                                onChange={handlePhoneChange}
                                placeholder="Digite o telefone"
                                required
                            />
                        </div>
                    </div>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary"  onClick={() =>onHide()}>
                    <i className="fa fa-close"></i> Cancelar
                </Button>
                <Button
                    variant="primary"
                    onClick={() =>handleSave()}
                    disabled={loadingSave}
                >
                    {loadingSave ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Salvando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-plus"></i> Cadastrar Funcionário
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OfficerModal;
